// src/components/Sidebar/SidebarStyles.js
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import { Link } from "react-router-dom";
import HeadingUI from "../UI/Text/Heading.jsx";   // Импортируем ваш Heading.jsx
import BodyTextUI from "../UI/Text/BodyText.tsx"; // Импортируем BodyText.jsx
import Icon from "../UI/Icon/Icon.tsx";

const COLLAPSED_WIDTH = 80;
const EXPANDED_WIDTH = 272;

export const SidebarContainer = styled(Box)(({ theme, isOpen }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: theme.spacing(2), // 16px
  gap: theme.spacing(4),     // 32px
  height: "100vh",
  minWidth: isOpen ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
  transition: "width 0.3s ease",
  backgroundColor: theme.palette.background.regular,
  borderRight: `1px solid ${theme.palette.border[10]}`
}));

export const SidebarHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  width: "100%",
  height: 40
}));

export const ToggleButton = styled(ButtonBase)(({ theme }) => ({
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: 24,
  padding: theme.spacing(1),
  color: theme.palette.TextAndIcon.primaryBlackBlueEnabled
}));

export const MenuList = styled(Box)(({ theme, $mb }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  
}));

export const MenuItemWrapper = styled(Link)(({ theme, disabled, isOpen }) => ({
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  cursor: "pointer",
  // Цвет текста/иконок
  color: theme.palette.TextAndIcon.primaryBlackBlueEnabled,
  // Отступы (8px сверху/снизу, 12px слева/справа)
  padding: theme.spacing(1, 1.5),
  // borderRadius 12px (убираем инлайн)
  borderRadius: 12,

  "&:hover": {
    backgroundColor: theme.palette.background.elements
  },

  ...(disabled && {
    pointerEvents: "none",
    opacity: 0.5
  }),

  ...(!isOpen && {
    justifyContent: "center"
  })
}));


export const LogoHeading = styled(HeadingUI)(({ theme }) => ({
  marginLeft: theme.spacing('12px') // ~9px
}));
export const LogoIcon = styled(Icon)(({ theme }) => ({
  marginLeft: theme.spacing('10px') // или theme.spacing(1.25), если хотите 10px через spacing
}));

export const MenuItemText = styled(BodyTextUI)(({ theme }) => ({
  marginLeft: theme.spacing('10px') // ~5px
}));
export const MenuListSupport = styled(MenuList)(({ theme }) => ({
  justifyContent:"end",
  marginTop: "auto", // прижимает к низу
  paddingBottom: "22px"
}));
export const MenuItemTextSupport= styled(BodyTextUI)(({ theme }) => ({
  marginLeft: theme.spacing('10px') // ~5px
}));